import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
var required = true;
export var PRIVACY_POLICY_FIELD = {
  field: {
    name: EFormFieldsNames.PrivacyPolicyAccepted,
    type: EExtendedFieldTypes.PrivacyPolicyCheckbox,
    required: required
  },
  validation: yup.boolean().when(EFormFieldsNames.AbstractWithPrivacyPolicy, {
    is: true,
    then: function then(schema) {
      return schema.required('Чтобы отправить сообщение, нужно согласиться').oneOf(
      // Из-за этого не будет работать валидатор если поле будет создаваться динамически, через createField(...).
      // Это не должно быть проблемой, так как это поле у нас будет всегда
      // в 1 экземпляре и не будет никак переиспользоваться.
      required ? [true] : [true, false], 'Чтобы отправить сообщение, нужно согласиться');
    }
  })
};